// Import external dependencies
//import 'jquery';
import 'slick-carousel/slick/slick.min.js';
import 'lightgallery.js/dist/js/lightgallery.min.js';
import 'lg-thumbnail.js/dist/lg-thumbnail.min.js';
import 'lg-video.js/dist/lg-video.min.js';
import 'modaal';
import 'accordionjs/accordion.js';
// Import everything from autoload


// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import singleProduct from './routes/single-product';
import single from './routes/single';


import templateLanding from './routes/template-landing';
import ajaxJs from './ajax';
import './fontawesome';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
  //Single product
  singleProduct,
  //Single post
  single,


  //Landing
  templateLanding,
  //Ajax
  ajaxJs,
});
//FontAwesome;
// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js